import { useIntl } from "react-intl";
import { xaiClientMoodColor } from "@lib/helpers/ColorHelper";
import { XAIClientMood } from "@lib/types/xAI";
import {
  PiSmiley,
  PiSmileyBlankLight,
  PiSmileyMehLight,
  PiSmileySad,
} from "react-icons/pi";
import { AppTag } from "@lib/components/AppComponents";
import { darken } from "polished";

type Props = {
  mood: XAIClientMood | string;
  size?: "small" | "default";
};

const XAIClientMoodTag = (props: Props) => {
  const { mood, size = "default" } = props;
  const { messages } = useIntl();

  const moodUpper = typeof mood === "string" ? mood.toUpperCase() : mood;
  const moodSize = size === "small" ? 12 : 14;

  const MoodIcon = () => {
    switch (moodUpper) {
      case XAIClientMood.POSITIVE:
        return <PiSmiley size={moodSize} />;
      case XAIClientMood.NEGATIVE:
        return <PiSmileySad size={moodSize} />;
      case XAIClientMood.NEUTRAL:
        return <PiSmileyMehLight size={moodSize} />;
      case XAIClientMood.UNKNOWN:
        return <PiSmileyBlankLight size={moodSize} />;
      default:
        return <PiSmileyBlankLight size={moodSize} />;
    }
  };

  const color = xaiClientMoodColor(moodUpper);

  return (
    <AppTag
      color={color}
      style={{
        fontSize: moodSize,
        borderColor: darken(0.3, color),
        borderWidth: 2,
        borderStyle: "solid",
      }}
      icon={<MoodIcon />}
    >
      {messages["enums.xaiClientMood"][moodUpper] || messages["common.na"]}
    </AppTag>
  );
};

export default XAIClientMoodTag;
